module.exports = __webpack_public_path__ + "img/address-brown-icon.b310b368.svg";